import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSlider } from '../../../../components/common/custom-slider';
import type { RelatedPostsProps } from './types';

const RelatedPosts: FC<RelatedPostsProps> = ({ relatedArticles }) => {
    const { t } = useTranslation();
    const items = !relatedArticles
        ? []
        : relatedArticles.map((article) => ({
              node: {
                  ...article,
                  slug: article.slug.replace(':', '').replace(/\/$/, ''),
              },
          }));

    return (
        <div className="slider-section">
            <div className=" max-w-5xl mx-auto px-5">
                <div className="related-slider">
                    <CustomSlider items={items} title={t('home.related_posts', 'Related Posts')} />
                </div>
            </div>
        </div>
    );
};

export default RelatedPosts;
